module.exports = __webpack_public_path__ + "delivery_truck_red.28dcb726da8fee2c1bd48519f2af26b9.svg";